import React from 'react'

const ErrorTemplateDesign = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-red-500 text-white text-2xl font-semibold">
  Error fetching the design
</div>
  )
}

export default ErrorTemplateDesign